var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.large ? '' : 'px-1',style:({height: _vm.large ? '' : '13px'}),attrs:{"x-small":!_vm.large || _vm.$vuetify.breakpoint.xsOnly,"small":_vm.large && _vm.$vuetify.breakpoint.smAndUp,"label":"","color":_vm.statusColor}},[_vm._v(" "+_vm._s(_vm.$t('project.status.' + _vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }